import { h } from "preact";
import { useContext, useEffect } from "preact/hooks";
import { Context, setLoginModalVisible } from "../lib/globalState";
import {
  addNoScroll,
  removeContextMenu,
  removeNoScroll,
  removeOverlay,
} from "../lib/helper";
import {
  useAuth,
  FacebookAuthProvider,
  GoogleAuthProvider,
  TwitterAuthProvider,
} from "../lib/preactfire";

export default function LoginModal() {
  const { dispatch } = useContext(Context);

  const auth = useAuth();

  useEffect(() => {
    addNoScroll();

    return () => {
      removeNoScroll();
    };
  }, []);

  const onSignin = async (provider) => {
    const response = await auth.signInWithPopup(provider);
    if (response) {
      removeOverlay();
      dispatch(setLoginModalVisible(false));
    }
  };

  const onFacebookLogin = () => onSignin(FacebookAuthProvider());

  const onGoogleLogin = () => onSignin(GoogleAuthProvider());

  const onTwitterLogin = () => onSignin(TwitterAuthProvider());

  return (
    <div id="myLoginModal" className="modal login-firebase show">
      <div className="modal-content">
        <div className="modal-header">
          <span style="font-size: 20px;">Log in</span>
          <span
            className="close"
            onClick={() => {
              removeOverlay();
              removeContextMenu();
              document
                .querySelectorAll(".comment-action-inner")
                .forEach((el) => {
                  el.style = "z-index:9";
                });
              dispatch(setLoginModalVisible(false));
            }}
          >
            <svg height="1em" fill="currentColor" viewBox="0 0 14 14">
              <path d="M7 5.586L1.414 0 0 1.414 5.585 7 0 12.586 1.414 14 7 8.414 12.586 14l1.413-1.414L8.414 7l5.585-5.586L12.586 0z" />
            </svg>
          </span>
        </div>
        <div className="sign-in-header">
          <img
            src={require("../assets/images/user-auth.svg")}
            className="comment-popup-img"
          />
          <h3>Log in to continue</h3>
        </div>
        <div className="sign-in-btn-wrapper">
          <div id="google-signin-btn" onClick={onGoogleLogin}>
            <span className="g-icon" />
            <span className="buttonText">Log in with Google</span>
          </div>
          <div id="facebook-signin-btn" onClick={onFacebookLogin}>
            <span className="f-icon" />
            <span className="buttonText">Log in with Facebook</span>
          </div>
          <div id="twitter-signin-btn" onClick={onTwitterLogin}>
            <span className="t-icon" />
            <span className="buttonText">Log in with Twitter</span>
          </div>
          <div className="modal-footer">
            <a
              href="https://www.goemotify.com/"
              className=""
              target="_blank"
              rel="noreferrer"
            >
              Home
            </a>
            <a
              href="https://www.goemotify.com/privacy"
              className=""
              target="_blank"
              rel="noreferrer"
            >
              Privacy
            </a>
            <a href="#" className="" target="_blank">
              Help
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
